import React from "react";
import { Link } from "react-router-dom";
import heroBg from "../../assets/images/bg/community1.jpg";
import { Container, Row, Col } from "react-bootstrap";
import "./style.scss";
import parse from "html-react-parser";

const HeroSection = ({ data }) => {
  return (
    <section className="section insurance-hero">
      <img className="insurance-shape" src={heroBg} alt="shape" />
      <Container className="">
        <Row className="align-items-center justify-content-between">
          <Col md={6} xs={12} className="mb-md-0 mb-5">
            <div className="text-md-start text-center">
              <p className="text-uppercase mb-4">{parse(data?.hero_title_small || "")}</p>
              <h1>{parse(data?.hero_title || "")}</h1>
              {data?.hero_sub_title ? <p>{parse(data?.hero_sub_title || "")}</p> : null}
              <div className="mt-5">
                <Link to="/select-insurance" className="btn btn-primary">
                  {data?.hero_button_title}{" "}
                </Link>
              </div>
            </div>
          </Col>

          <Col xl={5} md={6} xs={12} className="">
            {data?.hero_image1 !== undefined && (
              <div className="mx-xxl-5 px-xxl-5 mx-xl-0 px-xl-2 mx-lg-4 px-sm-4">
                <img className="img-fluid banner-left-img" src={data?.hero_image1} alt="hero img"/>
              </div>
            )}
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default HeroSection;
